<template>
  <!-- 综合运行监控 -->
  <div class="app-container">
    <!-- <div class="title-container">
      <span class="runDays"> 安全运行 {{ monitorData.runDays }} 天</span>
      {{ monitorData.iotPlatformName }}
      <span class="time">{{ timeStr }}</span>
    </div> -->
    <div class="flexct" style="padding-top: 20px;">
      <div class="left-box flex-sub" style="width: 0">
        <!-- <div class="title79">报警信息</div> -->
        <div class="left-box-1 flex">
          <div class="left-tip flex">
            <img
              src="/static/image/dtjk/left-tip-1.png"
              alt=""
              class="left-tip-img"
            />
            <div class="left-tip-color-1">电梯数量</div>
            <div class="left-tip-color-2 flex-sub text-right">
              {{ countVo.liftCount }}
            </div>
            <div class="left-tip-color-1">部</div>
          </div>
          <div class="left-tip flex">
            <img
              src="/static/image/dtjk/left-tip-2.png"
              alt=""
              class="left-tip-img"
            />
            <div class="left-tip-color-1">监控数量</div>
            <div class="left-tip-color-2 flex-sub text-right">
              {{ countVo.cameraCount }}
            </div>
            <div class="left-tip-color-1">个</div>
          </div>
          <div class="left-tip flex">
            <img
              src="/static/image/dtjk/left-tip-3.png"
              alt=""
              class="left-tip-img"
            />
            <div class="left-tip-color-1">在线数</div>
            <div class="left-tip-color-2 flex-sub text-right">
              {{ countVo.cameraOnlineCount }}
            </div>
            <div class="left-tip-color-1">个</div>
          </div>
        </div>
        <div class="left-box-2 no-scrollbar">
          <div
            class="left-2-bar mb10"
            v-for="(item, index) in liftRunningList"
            :key="index"
          >
            <div class="left-2-bar-title flex" @click="isShowFun(item)">
              <div class="flex-sub mr10">
                {{ item.buildingName
                }}<span style="color:#00F6FF">（{{ item.liftNum }}）</span>
              </div>
              <div
                class="mr10"
                style="color:#FF6666; font-size: 16px;"
                v-if="item.alarmLiftNum != ''"
              >
                【{{ item.alarmLiftNum }}个报警】
              </div>

              <span
                v-if="item.isShow"
                class="el-icon-arrow-down ml10 "
                style="color: #fff; font-size: 20px;"
              ></span>
              <span
                v-else
                class="el-icon-arrow-up ml10 "
                style="color: #fff; font-size: 20px;"
              ></span>
            </div>

            <div
              class="left-2-bar-con"
              style="display: flex;flex-wrap: wrap; justify-content: space-between;"
              v-if="item.isShow"
            >
              <div
                :class="{ warningState: i.alarmId != '' }"
                style="width: 49.3%;margin-bottom: 10px;cursor: pointer;"
                v-for="(i, x) in item.runningLogs"
                :key="x"
              >
                <div class="left-2-bar-con-item-title flex">
                  <div>{{ i.liftName }}</div>

                  <div
                    v-if="i.alarmId != ''"
                    class="text-cut flex-sub ml10"
                    style="color:#FF6666;"
                  >
                    报警信息：{{ i.alarmInfo }}
                  </div>

                  <div
                    v-if="i.alarmId != ''"
                    class="btn0709-sm"
                    style="margin-top: -6px;"
                    @click="showWarnInfoDlg(i, 'btn', index)"
                  >
                    详情
                  </div>

                  <img
                    class="ml10"
                    style="float: right;cursor: pointer"
                    src="/static/image/dtjk/icon_sxt.png"
                    alt=""
                    @click="showRealTimeMonitoringDlg(i)"
                  />
                </div>
                <div
                  class="mt6 left-2-bar-con-item-con"
                  style="display: flex;height: 166px;"
                >
                  <div class="l-con-left">
                    <div class="title text-center">
                      <img
                        v-if="i.alarmId != ''"
                        style="display: inline-block;position: absolute;top: 5px;left: 5px;"
                        src="/static/image/bjd_sy.png"
                        alt=""
                      />
                      <span style="margin-left: 30px;" v-if="i.alarmId != ''">{{
                        i.event
                      }}</span>
                      <span v-else>{{ i.event }}</span>
                    </div>
                    <div
                      :class="
                        i.alarmId != '' ? 'bgc_red_qian' : 'bgc_blue_qian'
                      "
                      style="height: 103px;text-align: center;"
                    >
                      <div class="flexcc" style="padding-top: 6px;">
                        <img
                          style="margin-right: 10px;"
                          :src="i.elevatorConditionImg"
                          alt=""
                        />
                        <div
                          style="font-size: 60px;display: inline-block;font-family: DIN-Dlglb;font-weight: 600;"
                        >
                          {{ i.elevname }}
                        </div>
                      </div>

                      <div style="font-size: 16px;" class="ttext-sd">
                        速度: {{ i.speed }} m/s
                      </div>
                    </div>
                    <div class="flexcc bottom">
                      <img
                        src="/static/image/dtjk/icon-persons.png"
                        alt=""
                        style="margin-top:-2px"
                      />
                      <div style="margin-left: 3px">{{ i.personcount }}人</div>
                    </div>
                  </div>

                  <div
                    class="l-con-right flex-sub ml10"
                    style="display: flex;align-items: center;"
                  >
                    <div>
                      <div>运行次数：{{ i.acelevtimes }}次</div>
                      <div class="mt20">运行里程：{{ i.acmile }}km</div>
                      <div class="mt20">开门次数：{{ i.acopentimes }}次</div>
                      <div class="mt20">运行时间：{{ i.actime }}分钟</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-box">
        <div class="title79">报警信息</div>
        <div class="right-list-box no-scrollbar">
          <div class="right-list">
            <!--  class="right-item warningState" -->
            <div
              v-for="(item, index) in liftCameraAlarms"
              :key="index"
              :class="{ 'right-item': true, warningState: item.isHandle != 1 }"
            >
              <div class="flex" style="padding: 10px;">
                <el-image
                  class="left-box-2-img"
                  :src="item.imgUrl"
                  :preview-src-list="[item.imgUrl]"
                  alt=""
                ></el-image>

                <div class="ml10 flex-sub" style="width:0">
                  <div class="text-cut">
                    {{
                      item.buildingName +
                        "-" +
                        item.unitName +
                        "-" +
                        item.liftName
                    }}
                  </div>
                  <div class="clearfix" style="margin-top: 14px;">
                    <div class="fl left-box-2-yellow">
                      {{ item.event || "" }}
                    </div>
                    <div
                      v-if="item.isHandle == 1"
                      class="fl ml10 left-box-2-blue"
                    >
                      已处理
                    </div>
                    <div v-else class="fl ml10" style="color:#FF6666">
                      未处理
                    </div>
                  </div>
                </div>
                <div
                  class="btn0709-sm ml10"
                  style="align-self: start"
                  @click="showWarnInfoDlg(item, '')"
                >
                  点击查看
                </div>
              </div>

              <div class="right-item-bottom flex">
                <div
                  v-if="item.alarmLevelKey == '一级'"
                  class="flexlc right-item-bottom-color-blue"
                >
                  <img
                    src="/static/image/dtjk/icon-warn-1.png"
                    alt=""
                    style="width: 18px; height: 18px; margin-top:-3px;"
                    class="mr6"
                  />
                  一级报警
                </div>
                <div
                  v-if="item.alarmLevelKey == '二级'"
                  class="flexlc right-item-bottom-color-yellow"
                >
                  <img
                    src="/static/image/dtjk/icon-warn-2.png"
                    alt=""
                    style="width: 18px; height: 18px; margin-top:-3px;"
                    class="mr6"
                  />
                  二级报警
                </div>
                <div
                  v-if="item.alarmLevelKey == '三级'"
                  class="flexlc right-item-bottom-color-red"
                >
                  <img
                    src="/static/image/dtjk/icon-warn-3.png"
                    alt=""
                    style="width: 18px; height: 18px; margin-top:-4px;"
                    class="mr6"
                  />
                  三级报警
                </div>

                <div class="flexlc right-item-bottom-time">
                  <img
                    src="/static/image/dtjk/icon-time.png"
                    alt=""
                    style="width: 16px; height: 15px; margin-top:-1px;"
                    class="mr6"
                  />
                  {{ item.createTime }}
                </div>
                <div class="flexlc right-item-bottom-people">
                  <img
                    src="/static/image/dtjk/icon-person.png"
                    alt=""
                    style="width: 16px; height: 15px; margin-top:-1px;"
                    class="mr6"
                  />
                  {{ item.personcount }}人
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <alarmDetailsDlg
      :dlgState0="dlgState"
      :dlgQuery="dlgQuery"
      :dlgType="dlgType"
      @closeDlg="closeDlg"
    />
    <GraphicsDlg
      :dlgState0="dlgState0"
      :dlgQuery="dlgQuery0"
      @closeDlg="closeGraphicsDlg"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookie from "js-cookie";

import * as utils from "@/utils";
import {
  integratedOperationMonitoring,
  integratedAbnormalAlarms,
  integratedATj, // 异常统计
  integratedABj // 异常趋势分析
} from "@/api/basicManSystem/comprehenOperateMonitor.js";

import alarmDetailsDlg from "@/views/leftMan/components/alarmDetailsDlg.vue";
import GraphicsDlg from "@/views/leftMan/components/graphicsDlg.vue";
import guanmen_red from "/static/image/guanmen_red.png";
import kaimen_red from "/static/image/kaimen_red.png";
import shangxing_red from "/static/image/shangxing_red.png";
import xiaxing_red from "/static/image/xiaxing_red.png";
import guanmen_blue from "/static/image/guanmen_blue.png";
import kaimen_blue from "/static/image/kaimen_blue.png";
import shangxing_blue from "/static/image/shangxing_blue.png";
import xiaxing_blue from "/static/image/xiaxing_blue.png";

import {
  liftCameraCount, // 监控数量
  liftCameraAlarms,
  liftRunningLogs
} from "@/api/leftMan";
let tsocket = "";
let scrollInterval = "";
export default {
  components: {
    alarmDetailsDlg,
    GraphicsDlg
  },
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.userInfo),
      listQuery: {
        projectId: "",
        projectName: ""
      },
      openIndex: "",
      countVo: {
        liftCount: 0,
        cameraCount: 0,
        cameraOnlineCount: 0
      },
      liftRunningList: [],
      interVal: "",
      interVal2: "",
      scrollHeight: "",
      liftCameraAlarms: [],
      forwardContent: "",
      forwardScrollBox: "",
      scrollContentHeight: 0, // 滚动内容的高度
      scrollBoxHeight: 0, // 滚动父级盒子的高度
      scrollableHeight: 0, // 可以滚动的高度
      scrollTop: 0, // 元素已经滚动的高度
      timer2: "", // 定时器

      dlgState: false,
      dlgQuery: {},
      dlgType: "",
      dlgState0: false,
      dlgQuery0: {},

      timeStr: utils.getTotime() + `(星期${utils.getWeek()})`,
      monitorData: {},

      isBindEvent: false,
      isPause: false,
      currentScrollPosition: 0
      /////////////
      // userInfo: JSON.parse(window.localStorage.userInfo),

      // alarmsData: {},

      // exceptionData: {},

      // echartPanel: null, // echart面板

      // timer: null,

      // tableTimer: null,

      // deviceList: [],

      // activeIdx: 0
    };
  },

  created() {
    this.getMonitor();
    // this.getAlarms();
    // this.getExceptionATj();
    // this.$nextTick(() => {
    //   this.changeTime();
    //   // this.scrollTable();
    // });

    this.getList();
  },

  mounted() {
    // window.addEventListener("resize", e => {
    //   setTimeout(() => {
    //     if (!utils.isNull(this.echartPanel)) {
    //       this.echartPanel.resize();
    //     }
    //   }, 400);
    // });
  },

  beforeDestroy() {
    if (scrollInterval) {
      this.currentScrollPosition = 0;
      clearInterval(scrollInterval);
      scrollInterval = null;
    }

    if (this.interVal2) {
      clearInterval(this.interVal2);
      this.interVal2 = null;
    }
    if (this.timer2) {
      clearInterval(this.timer2);
      this.timer2 = null;
    }
  },

  methods: {
    // 获取列表
    getList() {
      if (this.interVal2) {
        clearInterval(this.interVal2);
      }
      if (this.timer2) {
        clearInterval(this.timer2);
      }

      this.countVo.liftCount = 0;
      this.countVo.cameraCount = 0;
      this.countVo.cameraOnlineCount = 0;
      this.liftCameraAlarms = [];
      this.liftRunningList = [];
      this.getLiftCameraCount();
      this.getLiftCameraAlarms();
      this.getLiftRunningLogs();
      this.initWebsocket();
      this.interVal2 = setInterval(() => {
        // clearInterval(t.value);
        if (!this.isPause) {
          clearInterval(this.timer2);
          this.getLiftCameraCount();
          this.getLiftCameraAlarms();
        }
       
        // getLiftRunningLogs(projectId)
        // initWebsocket(projectId)
      }, 60000);
    },
    getLiftCameraCount() {
      liftCameraCount(this.userInfo["projectId"]).then(res1 => {
        let res = res1.data;
        console.log(res, "res");
        if (res.code == "200") {
          this.countVo = JSON.parse(JSON.stringify(res.data));
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    getLiftCameraAlarms() {
      liftCameraAlarms(this.userInfo["projectId"]).then(res1 => {
        let res = res1.data;
        console.log(res, "res");
        if (res.code == "200") {
          this.liftCameraAlarms = JSON.parse(JSON.stringify(res.list));
          if (utils.isNull(this.liftCameraAlarms)) {
            this.liftCameraAlarms = [];
          }
          if (this.liftCameraAlarms && this.liftCameraAlarms.length > 0) {
            for (let index = 0; index < this.liftCameraAlarms.length; index++) {
              if (utils.isNull(this.liftCameraAlarms[index].unitName)) {
                this.liftCameraAlarms[index].unitName = "";
              }
              // if (this.liftCameraAlarms[index].imgUrl) {
              //   this.liftCameraAlarms[index].imgUrl = this.liftCameraAlarms[
              //     index
              //   ].imgUrl
              //     .slice(0, 0)
              //     .concat("http://", this.liftCameraAlarms[index].imgUrl);
              // }
              //   this.liftCameraAlarms[index].createTime = dayjs(
              //     this.liftCameraAlarms[index].createTime
              //   ).format("YYYY-MM-DD HH:mm:ss");
            }

            setTimeout(() => {
              this.initR2AnimateFunc();
            }, 100);
            // if (this.liftCameraAlarms.length >= 4) {
            //   this.scrollHeight = this.liftCameraAlarms.length * 75;
            // } else {
            //   this.scrollHeight = 0;
            // }
            //lh---每行列表的高度，speed---滚动的速度，delay---间隔多久滚动一次,marqueeDOM---需要实现这个效果的dom, overflowY--超出部分的高度
            // this.$nextTick(() => {
            //   // listAutoScroll(169, 25, 1, forwardContent.value,20); // 方法调用
            //   this.regainHeight();
            // });
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    showRealTimeMonitoringDlg(row) {
      this.dlgState0 = true;
      this.dlgQuery0 = row;
    },
    closeGraphicsDlg() {
      this.dlgState0 = false;
    },
    getLiftRunningLogs() {
      liftRunningLogs(this.userInfo["projectId"]).then(res1 => {
        let res = res1.data;
        if (res.code == "200") {
          this.liftRunningList = JSON.parse(JSON.stringify(res.list));
          for (let index = 0; index < this.liftRunningList.length; index++) {
            this.liftRunningList[index].isShow = false;
            this.liftRunningList[0].isShow = true;
            for (
              let i = 0;
              i < this.liftRunningList[index].runningLogs.length;
              i++
            ) {
              let runningLogs = this.liftRunningList[index].runningLogs;
              // elevatorConditionImg
              if (utils.isNull(runningLogs[i].alarmId)) {
                runningLogs[i].alarmId = "";
              }
              if (utils.isNull(runningLogs[i].alarmInfo)) {
                runningLogs[i].alarmInfo = "";
              }
              runningLogs[i].elevatorConditionImg = "";
              if (!utils.isNull(runningLogs[i].elevname)) {
                runningLogs[i].elevname = this.formatNumber(
                  runningLogs[i].elevname
                );
              }
              // runningLogs[i].alarmId=''
              if (runningLogs[i].alarmId != "") {
                if (
                  runningLogs[i].dooropen == "关闭" &&
                  runningLogs[i].elevactpos == "静止"
                ) {
                  runningLogs[i].elevatorConditionImg = guanmen_red;
                }
                if (
                  runningLogs[i].dooropen == "打开" &&
                  runningLogs[i].elevactpos == "静止"
                ) {
                  runningLogs[i].elevatorConditionImg = kaimen_red;
                }
                if (
                  runningLogs[i].dooropen == "未知" &&
                  runningLogs[i].elevactpos == "静止"
                ) {
                  runningLogs[i].elevatorConditionImg = guanmen_red;
                }
                if (
                  runningLogs[i].dooropen == "未知" &&
                  runningLogs[i].elevactpos == "上行"
                ) {
                  runningLogs[i].elevatorConditionImg = shangxing_red;
                }
                if (
                  runningLogs[i].dooropen == "未知" &&
                  runningLogs[i].elevactpos == "下行"
                ) {
                  runningLogs[i].elevatorConditionImg = xiaxing_red;
                }
                if (
                  runningLogs[i].dooropen == "关闭" &&
                  runningLogs[i].elevactpos == "上行"
                ) {
                  runningLogs[i].elevatorConditionImg = shangxing_red;
                }
                if (
                  runningLogs[i].dooropen == "打开" &&
                  runningLogs[i].elevactpos == "下行"
                ) {
                  runningLogs[i].elevatorConditionImg = xiaxing_red;
                }
              }
              if (runningLogs[i].alarmId == "") {
                if (
                  runningLogs[i].dooropen == "关闭" &&
                  runningLogs[i].elevactpos == "静止"
                ) {
                  runningLogs[i].elevatorConditionImg = guanmen_blue;
                }
                if (
                  runningLogs[i].dooropen == "打开" &&
                  runningLogs[i].elevactpos == "静止"
                ) {
                  runningLogs[i].elevatorConditionImg = kaimen_blue;
                }
                if (
                  runningLogs[i].dooropen == "未知" &&
                  runningLogs[i].elevactpos == "静止"
                ) {
                  runningLogs[i].elevatorConditionImg = guanmen_blue;
                }
                if (
                  runningLogs[i].dooropen == "未知" &&
                  runningLogs[i].elevactpos == "上行"
                ) {
                  runningLogs[i].elevatorConditionImg = shangxing_blue;
                }
                if (
                  runningLogs[i].dooropen == "未知" &&
                  runningLogs[i].elevactpos == "下行"
                ) {
                  runningLogs[i].elevatorConditionImg = xiaxing_blue;
                }
                if (
                  runningLogs[i].dooropen == "关闭" &&
                  runningLogs[i].elevactpos == "上行"
                ) {
                  runningLogs[i].elevatorConditionImg = shangxing_blue;
                }
                if (
                  runningLogs[i].dooropen == "打开" &&
                  runningLogs[i].elevactpos == "下行"
                ) {
                  runningLogs[i].elevatorConditionImg = xiaxing_blue;
                }
              }
            }
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    formatNumber(num) {
      num = num.toString();
      return num[1] ? num : "0" + num;
    },
    isShowFun(i) {
      i.isShow = !i.isShow;
      this.$forceUpdate();
    },
    initWebsocket() {
      if (tsocket) {
        tsocket.close();
        tsocket = null;
      }
      let wsUrl = "wss://cloud.hrbweizhou.cn";
      tsocket = new WebSocket(
        wsUrl +
          "/websocket/camera-" +
          this.userInfo["projectId"] +
          "-" +
          this.userInfo["id"]
      );
      console.log(tsocket, "tsocket");
      tsocket.onopen = function(event) {
        console.log("WebSocket连接已打开！");
      };
      tsocket.onmessage = event => {
        // console.log("+++++websocket直接返回", event.data);

        let data = JSON.parse(event.data);
        if (utils.isNull(data.alarmId)) {
          data.alarmId = "";
        }
        // let num =data.elevname.toString();
        // data.elevname=num[1] ? num : "0" + num
        data.elevname = this.formatNumber(data.elevname);
        // console.log(this.liftRunningList, "liftRunningList");
        let devid0 = data.devid;
        for (let i = 0; i < this.liftRunningList.length; i++) {
          for (let j = 0; j < this.liftRunningList[i].runningLogs.length; j++) {
            if (
              this.liftRunningList[i].runningLogs[j].devid + "" ===
              devid0 + ""
            ) {
              let data0 = JSON.parse(
                JSON.stringify(this.liftRunningList[i].runningLogs[j])
              );
              if (data.alarmId) {
                this.liftRunningList[i].runningLogs[j] = JSON.parse(
                  JSON.stringify(data)
                );
              } else {
                this.liftRunningList[i].runningLogs[j] = JSON.parse(
                  JSON.stringify({
                    ...data,
                    alarmId: data0.alarmId,
                    alarmInfo: data0.alarmInfo,
                    alarmTime: data0.alarmTime,
                    event: data0.event
                  })
                );
              }
              data = this.liftRunningList[i].runningLogs[j];
              if (data.alarmId != "") {
                if (data.elevactpos == "上行") {
                  data.elevatorConditionImg = shangxing_red;
                } else if (data.elevactpos == "下行") {
                  data.elevatorConditionImg = xiaxing_red;
                } else if (data.dooropen == "打开") {
                  data.elevatorConditionImg = kaimen_red;
                } else {
                  data.elevatorConditionImg = guanmen_red;
                }
              }
              if (data.alarmId == "") {
                if (data.elevactpos == "上行") {
                  data.elevatorConditionImg = shangxing_blue;
                } else if (data.elevactpos == "下行") {
                  data.elevatorConditionImg = xiaxing_blue;
                } else if (data.dooropen == "打开") {
                  data.elevatorConditionImg = kaimen_blue;
                } else {
                  data.elevatorConditionImg = guanmen_blue;
                }
              }
              break;
            }
          }
        }
        this.liftRunningList = JSON.parse(JSON.stringify(this.liftRunningList));
      };

      tsocket.onclose = function(event) {
        console.log("WebSocket连接已关闭！", event);
      };

      tsocket.onerror = function(error) {
        console.error("WebSocket连接错误：", error);
      };
    },
    // regainHeight() {
    //   let scrollHeight = document.getElementById("inner").scrollHeight + 20;
    //   // 获取需要滚动元素的真实高度
    //   // this.scrollContentHeight= forwardContent.value.getBoundingClientRect().height
    //   this.scrollContentHeight =
    //     scrollHeight * this.liftCameraAlarms.length + 10;
    //   // 获取限制高度滚动容器的真实高度
    //   this.scrollBoxHeight = this.$refs[
    //     "forwardScrollBox"
    //   ].getBoundingClientRect().height;
    //   // 可以滚动的高度
    //   this.scrollableHeight = this.scrollContentHeight - this.scrollBoxHeight;
    //   console.log(
    //     "内容高度",
    //     this.scrollContentHeight,
    //     "盒子高度",
    //     this.scrollBoxHeight,
    //     "可以滚动的高度",
    //     this.scrollableHeight
    //   );
    //   this.autoScroll();
    // },
    // // 自动滚动
    // autoScroll() {
    //   this.timer2 = setInterval(() => {
    //     if (this.scrollableHeight >= this.scrollTop) {
    //       // 当为滚动到结尾时滚动
    //       this.scrollTop = this.$refs["forwardScrollBox"].scrollTop += 1.5;
    //     } else {
    //       // 滚动结束，清除当前定时器，scrollTop重置为0，继续滚动
    //       this.scrollTop = this.$refs["forwardScrollBox"].scrollTop = 0;
    //       clearInterval(this.timer2);
    //       this.autoScroll();
    //     }
    //   }, 20);
    // },
    // 鼠标移入时停止滚动
    // mouseenter() {
    //   if (this.interVal2) {
    //     clearInterval(this.interVal2);
    //   }
    //   clearInterval(this.timer2);
    // },
    // 鼠标移开继续滚动
    // mouseleave() {
    //   this.interVal2 = setInterval(() => {
    //     // clearInterval(t.value);
    //     clearInterval(this.timer2);
    //     this.getLiftCameraCount();
    //     this.getLiftCameraAlarms();
    //     // getLiftRunningLogs(projectId)
    //     // initWebsocket(projectId)
    //   }, 60000);
    //   this.autoScroll();
    // },
    showWarnInfoDlg(row, type, index0) {
      if (type == "btn") {
        row.id = row.alarmId;
      }
      this.openIndex = "";
      this.openIndex = index0;
      let isHandle = "";
      if (row.isHandle == 1) {
        this.dlgType = "info";
      } else {
        this.dlgType = "chuli";
      }
      this.dlgQuery = row;
      this.dlgState = true;
    },
    closeDlg(type) {
      this.dlgState = false;
      if (type == "chuli") {
        this.getList();
      }
    },
    // changeTime() {
    //   if (utils.isNull(this.timer)) {
    //     let _this = this;
    //     this.timer = setInterval(() => {
    //       _this.timeStr = utils.getTotime() + `(星期${utils.getWeek()})`;
    //     }, 1000);
    //   }
    // },

    getMonitor() {
      integratedOperationMonitoring().then(res => {
        if (res.data.code == 200) {
          this.monitorData = res.data.data;
          this.deviceList = [
            {
              label: "总设备数",
              count: this.monitorData.countEquipNum
            },
            {
              label: "在线设备",
              count: this.monitorData.countOnlineNum
            },
            {
              label: "离线设备",
              count: this.monitorData.countOfflineNum
            },
            {
              label: "异常报警",
              count: this.monitorData.countAlarmNum
            },
            {
              label: "待处理",
              count: this.monitorData.waitForAlarmNum
            }
          ];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    initR2AnimateFunc() {
      if (scrollInterval) {
        clearInterval(scrollInterval);
        scrollInterval = null;
      }

      var scrollElement = document.getElementsByClassName("right-list-box")[0];
      scrollElement.removeEventListener("mouseover", () => {});
      scrollElement.removeEventListener("mouseout", () => {});
      var box = document.getElementsByClassName("right-list")[0];
      let maxH = box.offsetHeight - scrollElement.offsetHeight + 20;

      this.currentScrollPosition = 0;
      scrollElement.scrollTop = 0;
      let scrollFunc = () => {
        var scrollSpeed = 0.36; // 滚动速度，单位为像素每秒
        scrollInterval = setInterval(() => {
          this.currentScrollPosition = utils.num2Round(
            this.currentScrollPosition + scrollSpeed,
            4
          );
          if (this.currentScrollPosition >= maxH) {
            this.currentScrollPosition = 0;
            scrollElement.scrollTop = 0;
          } else {
            scrollElement.scrollTop = this.currentScrollPosition;
          }
        }, 10);
      };
      if (maxH > 0) {
        scrollFunc();
      }
      setTimeout(() => {
        if (!this.isBindEvent) {
          scrollElement.addEventListener("mouseover", () => {
            this.isPause = true;
            if (scrollInterval) {
              clearInterval(scrollInterval);
              scrollInterval = null;
            }
          });
          scrollElement.addEventListener("mouseout", () => {
            this.isPause = false;
            if (maxH > 0) {
              this.currentScrollPosition = scrollElement.scrollTop;
              scrollFunc();
            }
          });
        }
        this.isBindEvent = true;
      }, 100);
    }

  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.title79 {
  font-size: 16px;
  // padding-bottom: 10px;
  line-height: 1;
  margin-left: 10px;
  padding-left: 10px;
  margin-bottom: 16px;
  font-weight: bold;

  color: #6ef3fc;
  border-left: 6px solid #6ef3fc
}
.left-box {
  height: calc(100vh - 152px);
  margin-right: 10px;
}

.left-tip {
  background: rgba(0, 186, 255, 0.1);
}

.left-tip {
  margin-right: 10px;
  border: 1px solid #369aff;
  flex: 1;
  padding-left: 4.4%;
  padding-right: 4.4%;
  height: 100px;
  font-size: 16px;

  &:last-child {
    margin-right: 0;
  }
}
.left-tip-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.left-tip-color-1 {
  color: #369aff;
  margin-right: 10px;
}
.left-tip-color-2 {
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  margin-right: 20px;
}

.left-box-2 {
  margin-top: 10px;
  height: calc(100vh - 144px);
  // border: 1px solid #369aff;
  overflow: auto;
}

.left-2-bar {
  background: rgba(0, 186, 255, 0.1);
}
.left-2-bar-title {
  font-size: 16px;
  font-weight: bold;
  padding: 14px;
  border: 1px solid #369aff;
  cursor: pointer;
}

.left-2-bar-con {
  border: 1px solid #369aff;
  border-top: none;
  padding: 18px;
}

.left-2-bar-con-item-title {
  height: 44px;
  background: rgba(0, 186, 255, 0.3);
  padding: 0 10px;
}
.right-box {
  width: 26vw;
  border: 1px solid #369aff;
  padding-top: 16px;
}
.right-list-box {
  height: calc(100vh - 84px);
  
  box-sizing: border-box;
  padding: 10px;
  overflow: auto;
  background: rgba(0, 186, 255, 0.1);
}
.right-item {
  width: 100%;
  // border: 1px solid #90afcf;
  margin-bottom: 15px;
  cursor: pointer;
  background: rgba(0, 186, 255, 0.2);
  // padding: 10px;
}
.left-box-2-img {
  width: 100px;
  height: 70px;
  // border: 1px solid #369aff;
}
.left-box-2-yellow {
  color: #faaa01;
}
.left-box-2-blue {
  color: #00a3fc;
}

.left-2-bar-con-item-con {
  margin-top: 10px;
  .l-con-left {
    width: 49%;
    height: 164px;
    // box-shadow: inset 0 0 10px rgba(0, 186, 255, 0.1);
    box-shadow: inset 0 0 10px #369aff; /* 内发光效果 */
    border: 1px solid #369aff;

    .title {
      font-size: 16px;
      height: 30px;
      line-height: 30px;
      background: rgba(0, 186, 255, 0.1);
    }
    .bottom {
      font-size: 16px;
      height: 30px;
      line-height: 30px;
      background: rgba(0, 186, 255, 0.1);
    }
  }
  .l-con-right {
    border: 1px solid #369aff;
    height: 164px;
    padding: 10px;
    padding-left: 20px;
  }
}

// right
.right-item-bottom {
  padding: 10px;
  // padding-top: 0;
  border-top: 1px solid #214579;
}

.right-item-bottom-color-blue {
  color: #00f6ff;
}

.right-item-bottom-color-yellow {
  color: #fa6501;
}
.right-item-bottom-color-red {
  color: #ff6666;
}
.right-item-bottom-time {
  color: #01d4f9;
}
.right-item-bottom-people {
  color: #aed7fe;
}
.btn0709 {
  background: url("/static/image/dtjk/btn-blue.png") left 8px no-repeat;
  background-size: 100% 100%;
  margin-left: 10px;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 130px;
  cursor: pointer;

  // &.active {
  //   background: url("/static/image/dtjk/btn-red.png") left 8px no-repeat;
  //   background-size: 100% 100%;
  // }
}

.btn0709-sm {
  background: url("/static/image/dtjk/btn-red-sm.png") left 8px no-repeat;
  background-size: 100% 100%;
  margin-left: 10px;
  text-align: center;
  height: 42px;
  line-height: 46px;
  width: 90px;
  cursor: pointer;

  // &.active {
  //   background: url("/static/image/dtjk/btn-red.png") left 8px no-repeat;
  //   background-size: 100% 100%;
  // }
}

// 报警时
.warningState {
  .btn0709 {
    background: url("/static/image/dtjk/btn-red.png") left 8px no-repeat;
    background-size: 100% 100%;
  }
  .left-2-bar-con-item-title {
    background: rgba(255, 102, 102, 0.2);
  }
  .left-2-bar-con-item-con {
    .l-con-left {
      box-shadow: inset 0 0 10px #ff6666;
      border: 1px solid #ff6666;
      .title,
      .bottom {
        background: rgba(56, 2, 2, 0.3);
      }
      .ttext-sd {
        color: #ff6666;
      }
    }
  }


  &.right-item {
    // border: 1px solid #ff6666;
    // .left-box-2-img {
    //   border-color: #ff6666;
    // }

    background: rgba(255, 102, 102, 0.3);

    .right-item-bottom {
      border-top: 1px solid #67455f;
    }
  }
}
.no-scrollbar {
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    overflow: hidden;
    display: none;
  }
}

.mr6 {
  margin-right: 6px;
}
.mt20 {
  margin-top: 20px;
}

.bgc_blue_qian {
  color: #448bfb;
}
.bgc_red_qian {
  color: #ff6666;
}
// 11111111111
.app-container {
  background: url("/static/image/equip/bg.png") no-repeat center;
  background-size: cover;
  padding: 0 20px;
  color: #fff;
  .title-container {
    position: relative;
    height: 96px;
    line-height: 88px;
    text-align: center;
    color: #ffffff;
    font-size: 36px;
    font-weight: bold;
    background: url("/static/image/equip/top-bj@2x.png") no-repeat center;
    background-size: 100% 100%;
    .runDays {
      position: absolute;
      left: 0;
      width: 492px;
      margin-bottom: 0;
      font-size: 20px;
      padding-top: 6px;
      text-align: center;
    }
    .time {
      position: absolute;
      width: 30%;
      right: 0;
      font-size: 20px;
      padding-top: 6px;
    }
  }

  .title {
    position: relative;
    color: #ffffff;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
  }

  /deep/ .el-table::before {
    height: 0px;
  }

  /deep/ .el-table {
    background: transparent;
    .el-table__body {
      tr:hover > td {
        color: #022d53;
        background: #a8e6f3;
      }
    }
    .el-table__header-wrapper {
      tr {
        background-color: transparent;
        th {
          color: #ffffff;
          background-color: rgba(0, 186, 255, 0.1);
          border: none;
          &.gutter {
            background: transparent;
          }
        }
      }
    }
    .el-table__body-wrapper {
      scrollbar-width: none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      tbody {
        tr {
          background: transparent;
          td {
            border: 1px solid #022d53;
            color: #a8e6f3;
          }
        }
      }
    }
  }
}
</style>
